<script>
    export let showGigasOption = true;

    let isCollapsed = false;

    export let onChangeMovilTerm;
    export let selectedMovilTerm;

    export let onChangeMovilMobileData;
    export let selectedMovilMobileData;
</script>

<button class="config-button" on:click={() => (isCollapsed = !isCollapsed)}>
    <p>Configura tu izzi móvil</p>
    <svg class="icon {!isCollapsed && 'is-rotated'}" aria-hidden="true"
        ><use xlink:href="/assets/img/icons/symbol-defs.svg#icon-angle-left"
        ></use></svg
    >
</button>
{#if !isCollapsed}
    <div class="config-container">
        <div class="config-item">
            <p>
                1. Selecciona el <span class="fw-bold">plazo</span> de contratación
                de tu izzi movil
            </p>
            <div class="config-box-container">
                <button
                    class="config-box {selectedMovilTerm ==
                        'with-forced-term' && 'config-box-active'}"
                    on:click={() =>
                        onChangeMovilTerm({
                            target: { value: 'with-forced-term' },
                        })}
                >
                    {#if selectedMovilTerm == 'with-forced-term'}
                        <div class="offer-option-check">
                            <img
                                src="/assets/img/icons/check-option-pink.svg"
                                alt="móvil"
                            />
                        </div>
                    {/if}
                    contrato a 12 meses
                </button>
                <button
                    class="config-box {selectedMovilTerm ==
                        'without-forced-term' && 'config-box-active'}"
                    on:click={() =>
                        onChangeMovilTerm({
                            target: { value: 'without-forced-term' },
                        })}
                >
                    {#if selectedMovilTerm == 'without-forced-term'}
                        <div class="offer-option-check">
                            <img
                                src="/assets/img/icons/check-option-pink.svg"
                                alt="móvil"
                            />
                        </div>
                    {/if}
                    sin plazo fijo
                </button>
            </div>
        </div>
        {#if showGigasOption}
            <div class="config-item">
                <p>
                    2. Selecciona la cantidad de <span class="fw-bold"
                        >gigas</span
                    > que deseas para navegar y compartir
                </p>
                <div class="config-box-container">
                    {#if selectedMovilTerm == 'with-forced-term'}
                        <button
                            class="config-box {selectedMovilMobileData ==
                                '5-gb-plan' && 'config-box-active'}"
                            on:click={() =>
                                onChangeMovilMobileData({
                                    target: { value: '5-gb-plan' },
                                })}
                        >
                            {#if selectedMovilMobileData == '5-gb-plan'}
                                <div class="offer-option-check">
                                    <img
                                        src="/assets/img/icons/check-option-pink.svg"
                                        alt="móvil"
                                    />
                                </div>
                            {/if}
                            5GB
                        </button>
                    {/if}
                    <button
                        class="config-box {selectedMovilMobileData ==
                            '8-gb-plan' && 'config-box-active'}"
                        on:click={() =>
                            onChangeMovilMobileData({
                                target: { value: '8-gb-plan' },
                            })}
                    >
                        {#if selectedMovilMobileData == '8-gb-plan'}
                            <div class="offer-option-check">
                                <img
                                    src="/assets/img/icons/check-option-pink.svg"
                                    alt="móvil"
                                />
                            </div>
                        {/if}
                        8GB
                    </button>
                    {#if selectedMovilTerm == 'without-forced-term'}
                        <button
                            class="config-box {selectedMovilMobileData ==
                                '15-gb-plan' && 'config-box-active'}"
                            on:click={() =>
                                onChangeMovilMobileData({
                                    target: { value: '15-gb-plan' },
                                })}
                        >
                            {#if selectedMovilMobileData == '15-gb-plan'}
                                <div class="offer-option-check">
                                    <img
                                        src="/assets/img/icons/check-option-pink.svg"
                                        alt="móvil"
                                    />
                                </div>
                            {/if}
                            15GB
                        </button>
                    {/if}
                    <button
                        class="config-box {selectedMovilMobileData ==
                            'unlimited-plan' && 'config-box-active'}"
                        on:click={() =>
                            onChangeMovilMobileData({
                                target: { value: 'unlimited-plan' },
                            })}
                    >
                        {#if selectedMovilMobileData == 'unlimited-plan'}
                            <div class="offer-option-check">
                                <img
                                    src="/assets/img/icons/check-option-pink.svg"
                                    alt="móvil"
                                />
                            </div>
                        {/if}
                        ilimitado
                    </button>
                </div>
            </div>
        {/if}
    </div>
{/if}
